import React, { Component } from "react";
import { Button } from "@vds/buttons";
import { Title, Body } from "@vds/typography";
import { Grid, Row, Col } from "@vds/grids";
import NavHeader from '../../Common/NavHeader/NavHeader';
import { connect } from 'react-redux';
import * as SiteAnalytics from '../../sitecatalyst';
import * as ChatAnalytics from '../../utils/lpchatMetrics';
import "./SaveCart.css";
import { refreshChatHashTag } from '../../utils/common';
import { getChatInfo } from './containers/actions';
import {  updatePageLoadType, updateIsCheckoutPageVisited, getRetrieveCartInfo, updateIsSaveCartPageVisited } from '../CustomizeOrder/containers/actions';
import { MarginSpacerL } from "../Checkout/styleTag";

class SaveCartConfirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initiateChat: false,
      endInteraction: false,
    };
    
  }
  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.setState({initiateChat: true});
    this.setState({ endInteraction: true });
  }

  componentDidUpdate = () => {
    if(this.state.endInteraction && navigator?.userAgentData?.platform !== "macOS") {
      window.newrelic.interaction().end();
      this.setState({ endInteraction: false });
    }
    if (this.state.initiateChat) {
      SiteAnalytics.trackPageInfo('SaveCartConfirmation');
      ChatAnalytics.setPurchaseTracking(this.props.getFloatCartResponse, '');
      this.props.getChatInfo("checkout");
      // For Chat Refresh On URL Change..
      refreshChatHashTag();
      this.setState({initiateChat: false});
    }
  }
  
  backToOrderClick = () => {
  this.props.updatePageLoadType('R');
  this.props.updateIsCheckoutPageVisited('N');
  this.props.updateIsSaveCartPageVisited('Y');
  this.props.getRetrieveCartInfo({ callback: (function() {
    this.props.history.go(-2);
  }).bind(this) });
  };
  render() {
    const { LQPost} = this.props;
    return (
      <div className="save-cart save-cart-confirmation">
         {/* <div className={`sticky-wrapper sticky'`} >
                <NavHeader
                    customizeOrder={[]}
                    selectedServiceVoice={null}
                    globalscope={LQPost ? LQPost : {}}
                    hideCart
                />
            </div> */}
        <Grid>
          <Row>
            <Col className="save-cart-Col" colSizes={{ mobile: 4, desktop: 12, tablet: 12 }}>
              <div className="Page-Title">
                <Title size="large" primitive="h1">
                Email sent
                </Title>
              </div>
              <div className="confirmation-message">
                <Body size="small" primitive="h2">
                We sent you an email with a link to your saved cart. You can pick up where you left off, or continue with your order below.
                </Body>
              </div>
            </Col>
          </Row>
          <MarginSpacerL/>
          <Row>
            <div className="Submit-Button">
              <Button onClick={this.backToOrderClick}>Back to Order</Button>
            </div>
          </Row>
        </Grid>
      </div>
    );
  }
}
const mapStateToProps = state => {
  const { AddressValidationPage,  CustomizeOrder} = state;
    return {
      LQPost: AddressValidationPage?.addressQualificationDetails?.LQPost,
      getFloatCartResponse: CustomizeOrder.getFloatCartResponse
    }
}
const mapDispatchToProps = (dispatch) => ({
  getChatInfo: (data) => dispatch(getChatInfo(data)),
  updatePageLoadType: (data) => dispatch(updatePageLoadType(data)),
  updateIsCheckoutPageVisited: (data) =>dispatch(updateIsCheckoutPageVisited(data)),
  updateIsSaveCartPageVisited: (data) =>dispatch(updateIsSaveCartPageVisited(data)),
  getRetrieveCartInfo: (data) => dispatch(getRetrieveCartInfo(data)),
});

  SaveCartConfirmation = connect(mapStateToProps, mapDispatchToProps)(SaveCartConfirmation);

export default SaveCartConfirmation;
